// Animation and timing constants
export const SCALE_DURATION = 500; // Bar scaling duration in ms
export const TIMEOUT_DURATION = 5000; // View timeout in ms
export const HEALTH_CHECK_INTERVAL = 60000; // Health check interval in ms
export const CLOCK_SKEW_UPDATE_INTERVAL = 15000; // Clock skew update interval in ms
export const ANIMATION_FRAME_RATE = 16; // ~60fps animation update rate in ms
export const VIEW_UPDATE_INTERVAL = 50; // View re-render interval in ms

// Latency thresholds (in ms)
export const LATENCY_THRESHOLDS = {
  OPTIMAL: 200,
  GOOD: 400,
  SLOW: 800,
  CRITICAL: 2000,
} as const;

// Latency zone configuration
export const LATENCY_ZONES = {
  optimal: {
    min: 0,
    max: LATENCY_THRESHOLDS.OPTIMAL,
    color: "#10b981",
    label: "BLAZING FAST",
    icon: "🏎️",
  },
  good: {
    min: LATENCY_THRESHOLDS.OPTIMAL,
    max: LATENCY_THRESHOLDS.GOOD,
    color: "#f59e0b",
    label: "AUTOBAHN SPEED",
    icon: "🚗",
  },
  slow: {
    min: LATENCY_THRESHOLDS.GOOD,
    max: LATENCY_THRESHOLDS.SLOW,
    color: "#f97316",
    label: "TRAFFIC JAM",
    icon: "🚙",
  },
  critical: {
    min: LATENCY_THRESHOLDS.SLOW,
    max: LATENCY_THRESHOLDS.CRITICAL,
    color: "#ef4444",
    label: "ROADBLOCK",
    icon: "🚨",
  },
} as const;

// Network configuration
export const MAX_VIEWS_STORED = 50; // Maximum number of views to keep in state
export const DEFAULT_SHARD_COUNT = 8; // Default number of shards
export const EPOCH_SIZE = 10; // Blocks per epoch

// Reconnection settings
export const WS_RECONNECT_DELAY = 11000; // WebSocket reconnect delay in ms
export const RATE_LIMIT_THRESHOLD = 1000; // Time threshold to detect rate limiting in ms

// UI configuration
export const BAR_MIN_WIDTH_MOBILE = 30;
export const BAR_MIN_WIDTH_DESKTOP = 60;
export const BAR_MIN_SEGMENT_WIDTH_MOBILE = 15;
export const BAR_MIN_SEGMENT_WIDTH_DESKTOP = 30;
export const VIEW_INFO_WIDTH_MOBILE = 50;
export const VIEW_INFO_WIDTH_DESKTOP = 80;
export const MOBILE_BREAKPOINT = 768;
